/**
 * Protocol-specific property labels
 * Single source of truth for protocol field display names used across:
 * - CSV column headers (bulk operations)
 * - Metadata display (tile glossary, search results)
 * - Point discovery interfaces
 */
export enum ProtocolPropertyLabel {
  // BACnet properties
  BACNET_INSTANCE_NUMBER = 'BACnet Instance Number',
  BACNET_OBJECT_TYPE = 'BACnet Object Type',

  // Modbus properties
  MODBUS_ADDRESS = 'Modbus Address',
  MODBUS_DATA_TYPE = 'Modbus Data Type',
  MODBUS_BYTE_ORDER = 'Modbus Byte Order',
  MODBUS_FUNCTIONS = 'Modbus Functions',

  // LoRaWAN properties
  LORAWAN_POINT_NAME = 'LoRaWAN Point Name',
  LORAWAN_DATA_SOURCE = 'LoRaWAN Data Source',
  LORAWAN_DATA_TYPE = 'LoRaWAN Data Type'
}
